import { AuthenticationService } from '../authentication-service/authentication.service';
import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard {
  private authenticationService = inject(AuthenticationService);
  private toastrService = inject(ToastrService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const allowed = route.data['roles'].every((role: string) => this.authenticationService.hasRole(role));
    if (!allowed) {
      this.toastrService.error('Permission denied');
    }
    return allowed;
  }
}
